<!-- Zweck: Stellt die HTML-Struktur für shop supplier menu component im Frontend bereit. -->
<div class="suppliermenu">
  <div class="title">Lieferant auswählen</div>
  @for (s of ssvc.supplier|async; track s) {
    <div (click)="selectSuppier(s)" class="menuitem">
      {{s.name}}
    </div>
  }
</div>
